import { render, staticRenderFns } from "./AddEditClaim.vue?vue&type=template&id=297b195b&scoped=true"
import script from "./AddEditClaim.vue?vue&type=script&lang=js"
export * from "./AddEditClaim.vue?vue&type=script&lang=js"
import style0 from "./AddEditClaim.vue?vue&type=style&index=0&id=297b195b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b195b",
  null
  
)

export default component.exports